import { Component, OnInit } from '@angular/core';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-custom-right-panel-uk',
  standalone: false,
  templateUrl: './custom-right-panel-uk.component.html',
  styleUrl: './custom-right-panel-uk.component.scss',
})
export class CustomRightPanelUkComponent {
  bannerData$: Observable<CmsBannerComponent> = this.component.data$
  
  constructor(public component:CmsComponentData<CmsBannerComponent>,protected config:OccConfig){}

  getImageUrl(media: any): string {
    return this.config.backend?.occ?.baseUrl + media.url;
  }
}
